var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVariantAScalability = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 102,
    viewBox: "0 0 97 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_14772)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6368 29.9171C17.6289 39.9327 17.6289 56.1713 28.6368 66.187C39.6447 76.2026 57.492 76.2026 68.4999 66.187C79.5078 56.1713 79.5078 39.9327 68.4999 29.9171L49.35 12.4933C48.9183 12.1005 48.2184 12.1005 47.7867 12.4933L28.6368 29.9171ZM36.6104 54.9071H45.1521V58.3237H36.6104V54.9071ZM60.5272 54.9071H57.1105V58.3237H60.5272V54.9071ZM48.5691 54.9071H53.6941V58.3237H48.5691V54.9071ZM35.3904 34.4071H61.7475L63.944 36.6848V51.4904H33.194V36.6848L35.3904 34.4071ZM43.444 37.8237V48.0737H40.0274V37.8237H43.444ZM50.2775 37.8237V48.0737H46.8608V37.8237H50.2775ZM57.1111 48.0737V37.8237H53.6945V48.0737H57.1111Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_14772",
    x: 0.380859,
    y: 0.19873,
    width: 96.375,
    height: 101.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_14772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_14772",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVariantAScalability);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iMTAyIiB2aWV3Qm94PSIwIDAgOTcgMTAyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9kXzFfMTQ3NzIpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC42MzY4IDI5LjkxNzFDMTcuNjI4OSAzOS45MzI3IDE3LjYyODkgNTYuMTcxMyAyOC42MzY4IDY2LjE4N0MzOS42NDQ3IDc2LjIwMjYgNTcuNDkyIDc2LjIwMjYgNjguNDk5OSA2Ni4xODdDNzkuNTA3OCA1Ni4xNzEzIDc5LjUwNzggMzkuOTMyNyA2OC40OTk5IDI5LjkxNzFMNDkuMzUgMTIuNDkzM0M0OC45MTgzIDEyLjEwMDUgNDguMjE4NCAxMi4xMDA1IDQ3Ljc4NjcgMTIuNDkzM0wyOC42MzY4IDI5LjkxNzFaTTM2LjYxMDQgNTQuOTA3MUg0NS4xNTIxVjU4LjMyMzdIMzYuNjEwNFY1NC45MDcxWk02MC41MjcyIDU0LjkwNzFINTcuMTEwNVY1OC4zMjM3SDYwLjUyNzJWNTQuOTA3MVpNNDguNTY5MSA1NC45MDcxSDUzLjY5NDFWNTguMzIzN0g0OC41NjkxVjU0LjkwNzFaTTM1LjM5MDQgMzQuNDA3MUg2MS43NDc1TDYzLjk0NCAzNi42ODQ4VjUxLjQ5MDRIMzMuMTk0VjM2LjY4NDhMMzUuMzkwNCAzNC40MDcxWk00My40NDQgMzcuODIzN1Y0OC4wNzM3SDQwLjAyNzRWMzcuODIzN0g0My40NDRaTTUwLjI3NzUgMzcuODIzN1Y0OC4wNzM3SDQ2Ljg2MDhWMzcuODIzN0g1MC4yNzc1Wk01Ny4xMTExIDQ4LjA3MzdWMzcuODIzN0g1My42OTQ1VjQ4LjA3MzdINTcuMTExMVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZF8xXzE0NzcyIiB4PSIwLjM4MDg1OSIgeT0iMC4xOTg3MyIgd2lkdGg9Ijk2LjM3NSIgaGVpZ2h0PSIxMDEuNSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSI4Ii8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjEwIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDEgMCAwIDAgMCAxIDAgMCAwIDAgMSAwIDAgMCAwLjkgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd18xXzE0NzcyIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93XzFfMTQ3NzIiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";